import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ children, header, footer }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            {header && (
                <a
                    href='#main'
                    className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-ink focus:shadow-lg'
                >
                    Skip to content
                </a>
            )}

            {header}

            <main id='main' className='flex-1'>
                {children}
            </main>

            {footer}
        </div>
    )
}
